import { z } from "zod";

export const NotificationValidationSchema = z.object({
  text: z
    .string()
    .min(1, "Notification text is required.")
    .transform((val) => val.trim()),
  order_number: z
    .string()
    .transform((val) => val.trim() || "1")
    .refine((val) => !isNaN(Number(val)) && Number.isInteger(Number(val)), {
      message: "Order number must be a valid number",
    })
    .refine((val) => Number(val) > 0, {
      message: "Order number must be greater than 0",
    }),
});
